import type { FieldSelectTagProps } from "./field-select-tag.type";

import classNames from "classnames";

import { FieldSelect, getFieldSelectOption } from "@/ui/field-select";
import { Tag } from "@/ui/tag";

import "./field-select-tag.style.less";

export const FieldSelectTag = ({
  options,
  noMarginBottom,
  className,
  dropdownClassName,
  ...props
}: FieldSelectTagProps) => {
  return (
    <FieldSelect
      {...props}
      options={options}
      variant="borderless"
      labelRender={(label) => {
        const option = getFieldSelectOption(label.value, options);
        return (
          <Tag variant="solid" color={option?.color}>
            {option?.label}
          </Tag>
        );
      }}
      optionRender={(option) => (
        <Tag variant="solid" color={option.data.color}>
          {option.data.label}
        </Tag>
      )}
      className={classNames("field-select-tag", {
        "-no-margin-bottom": noMarginBottom,
        className,
      })}
      classNames={{
        root: "field-select-tag--root",
        content: "field-select-tag--content",
        suffix: "field-select-tag--suffix",
        popup: {
          root: classNames("field-select-tag-dropdown", dropdownClassName),
        },
      }}
    />
  );
};
